// extracted by mini-css-extract-plugin
export var anchor = "_2v-0";
export var discard = "_2v-4";
export var muiTooltipTooltip = "_2v-6";
export var notificationBar = "_2v-3";
export var saveButtonHoverSlotWrapper = "_2v-5";
export var show = "_2v-2";
export var spacer = "_2v-1";